import {FC, useEffect} from 'react';

import {useDispatch, useSelector} from '~/store/hooks';
import ContactUsModal from '~/modals/ContactUsModal';
import RemovalRequestModal from '~/modals/RemovalRequestModal';
import {ImagePreviewModal} from '~/modals/ImagePreviewModal/ImagePreviewModal';
import SnackBar from '~/app-header/components/SnackBar';

import Header from './components/Header';
import {HeaderType} from './components/Header/Header';
import {useAppNotifications} from './useAppNotifications';

const getHeaderType = () => {
  const {APP_CONFIG} = window;

  if (APP_CONFIG.page.isRootPage) {
    return HeaderType.Main;
  }

  if (APP_CONFIG.flags.showHeaderSearch) {
    return HeaderType.Search;
  }

  if (APP_CONFIG.page.isModal) {
    return HeaderType.Light;
  }

  return HeaderType.PersonalArea;
};

const App: FC = () => {
  const dispatch = useDispatch();
  const headerType = getHeaderType();
  const isGuest = useSelector(({profile}) => profile.isGuest);

  useAppNotifications();

  useEffect(() => {
    if (isGuest) {
      return;
    }

    dispatch.profile.startNotificationsPulling();
  }, []);

  return (
    <>
      <SnackBar />
      <Header variant={headerType} />
      <RemovalRequestModal />
      <ContactUsModal />
      <ImagePreviewModal />
    </>
  );
};

export default App;
